<template>
    <Teleport to="body">
        <ModalOverlay v-if="visible" @click="closeModal" />
        <div v-if="visible" class="custom-modal" :style="{ width }">
            <div class="modal-content">
                <ModalHeader :title="title" @close="closeModal" />
                <ModalBody>
                    <slot></slot>
                </ModalBody>
                <ModalFooter>
                    <slot name="footer"></slot>
                </ModalFooter>
            </div>
        </div>
    </Teleport>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalHeader from "./ModalHeader.vue";
import ModalBody from "./ModalBody.vue";
import ModalFooter from "./ModalFooter.vue";
import ModalOverlay from "./ModalOverlay.vue";

export default defineComponent({
    name: "BaseModal",
    components: { ModalHeader, ModalBody, ModalFooter, ModalOverlay },
    props: {
        title: { type: String, required: true },
        visible: { type: Boolean, required: true },
        width: { type: String, default: "500px" },
    },
    emits: ["close"],
    methods: {
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>

<style scoped>
.custom-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 48px);
    overflow-y: auto;
    background: #fff;
    border-radius: 20px;
    z-index: 1050;
    box-shadow: var(--au-shadow-lg);
}

.modal-content {
    padding: 22px 24px;
    border: 0;
    background: transparent;
}
</style>